import { Base } from 'src/api/Base'
import { FingerprintService } from 'src/services'

export class AuthAPI extends Base {
  static get entity() {
    return 'auth'
  }

  static async login({ username, password, rememberme }) {
    const fingerprint = await FingerprintService.get()
    const body = {
      username,
      password,
      fingerprint,
      rememberme,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/login`, body)
    return data
  }

  static async checkPhoneCode({ username, code, rememberme, form }) {
    const fingerprint = await FingerprintService.get()
    const body = {
      username,
      code,
      rememberme,
      form,
      fingerprint,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/check-phone-code`, body)
    return data
  }

  static async restorePassword({ token, password }) {
    const fingerprint = await FingerprintService.get()
    const body = {
      token,
      password,
      fingerprint,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/restore-password`, body)
    return data
  }

  static async resetPassword({ username }) {
    const body = {
      username,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/reset-password`, body)
    return data
  }

  static async invite({ phone, username, new_password, password, rememberme }) {
    const body = {
      phone,
      username,
      new_password,
      password,
      rememberme,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/invite`, body)
    return data
  }

  static async refreshToken({ refreshToken }) {
    const fingerprint = await FingerprintService.get()
    const body = {
      refreshToken,
      fingerprint,
    }
    const { data } = await this.request({
      auth: false,
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/token`, body)
    return data
  }

  static async logout() {
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/logout`)
    return data
  }

  static async getPasswordSettings() {
    const { data } = await this.request().get(`/${this.entity}/password-settings`)
    return data
  }
}
